'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _chevron = require('./svg/chevron');

var _chevron2 = _interopRequireDefault(_chevron);

var _search = require('./svg/search');

var _search2 = _interopRequireDefault(_search);

var _searchClear = require('./svg/search-clear');

var _searchClear2 = _interopRequireDefault(_searchClear);

var _userFilled = require('./svg/user-filled');

var _userFilled2 = _interopRequireDefault(_userFilled);

var _userHollow = require('./svg/user-hollow');

var _userHollow2 = _interopRequireDefault(_userHollow);

var _userLoggedIn = require('./svg/user-logged-in');

var _userLoggedIn2 = _interopRequireDefault(_userLoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    chevron: _chevron2.default,
    search: _search2.default,
    searchClear: _searchClear2.default,
    userFilled: _userFilled2.default,
    userHollow: _userHollow2.default,
    userLoggedIn: _userLoggedIn2.default
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/index.js
 ** module id = 472
 ** module chunks = 1
 **/